import * as React from 'react'
import { useMemo } from 'react'

import type { CustomFieldProps } from './typings'
import { AdditionalInfoListItem } from '@sales-center/components'
import { aggregateFieldOptions } from '@user/store/customFields'
import {
  type CustomFieldMultiValue,
  sortArrayByArray,
} from '@sales-center/common'

type CustomMultiSelectProps = CustomFieldProps & {
  value: CustomFieldMultiValue
}

export function CustomMultiSelect(props: CustomMultiSelectProps) {
  const {
    customFields,
    customFieldOptions,
    value: { customFieldId, customFieldValueOptions: selectedOptions },
  } = props

  const { field, subtitle } = useMemo(() => {
    const selectedIds = selectedOptions?.map((x) => x.customFieldOptionId) ?? []

    const field = customFields.find((x) => x.id === customFieldId)

    const options = aggregateFieldOptions(
      customFieldId,
      customFieldOptions,
    ).filter((x) => selectedIds.includes(x.id))

    const subtitle = sortArrayByArray(options, selectedIds, (o) => o.id)
      .map((x) => x.name)
      .join(', ')

    return {
      field,
      subtitle,
    }
  }, [customFieldId, customFieldOptions, customFields, selectedOptions])

  if (!field) return null

  return <AdditionalInfoListItem title={field?.name} subtitle={subtitle} />
}
